export default "__VITE_ASSET__h$n8u$Vc__"